/**
 * src/lib/slug.js
 * Category/subcategory are free-text in the database (whatever's typed in
 * the admin panel), not a fixed list — so URL segments are derived by
 * slugifying on the fly, and matched back by comparing slugs, rather than
 * storing a separate slug column for every facet value.
 */

export function slugify(text) {
  return (text || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

/** Finds the real value in `values` whose slug matches `slug`, or undefined. */
export function findBySlug(values, slug) {
  if (!slug) return undefined;
  return values.find((v) => slugify(v) === slug);
}